<template>
  <v-content pa-0>
    <nav id="navBar" style="width: 100%; background-color: white; z-index: 100;position: fixed"
      v-if="$vuetify.breakpoint.mdAndUp">
      <v-layout py-2 px-4>
        <v-flex shrink align-center style="display: flex">
          <a @click="hrefTo('/')">
            <img style="width: 130px;user-select: none;cursor: pointer" :src="require('../assets/cea-logo.png')" />
          </a>
        </v-flex>
        <v-flex md9 xl6 align-center style="display: flex; justify-content: flex-start; margin-left: 20px;">
          <v-layout class="navtxt" style="width: 100%;">
            <v-flex v-if="firstMenu.name_en && firstMenu.name_th" style="flex: none; margin-right: 32px;">
              <v-menu offset-y transition="slide-y-transition" bottom>
                <template v-slot:activator="{ on }">
                  <span style="user-select: none; cursor: pointer"
                    :class="{ 'nav-active': $route.path === '/international' || $route.path === '/country' }" v-on="on">
                    {{ language === 'en' ? firstMenu.name_en : firstMenu.name_th }}
                  </span>
                </template>
                <v-list>
                  <v-list-item v-for="(item, i) in items" :key="i" @click="$router.push('/' + item.name)">
                    <v-list-item-title class="navtxt" :class="{ 'nav-active': $route.path === '/' + item.name }">
                      <template v-if="language == 'en'">{{ item.title_en }}</template>
                      <template v-else>{{ item.title_th }}</template>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-flex>
            <v-flex v-for="(item, i) in menu" :key="i" style="flex: none; margin-right: 32px;">
              <span @click="$router.push('/' + item.src_url)" style="user-select: none; cursor: pointer"
                :class="{ 'nav-active': $route.path === '/' + item.src_url }">
                <template v-if="language == 'en'">{{ item.name_en }}</template>
                <template v-else>{{ item.name_th }}</template>
              </span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-spacer></v-spacer>
        <v-flex shrink align-center style="display: flex;">
          <v-btn-toggle color="#FF5100">
            <v-btn text id="lang" color="#FF5100" class="navtxt"
              @click="language === 'en' ? langSwitcher('th') : langSwitcher('en')">{{ language === 'en' ?
                'TH' : 'EN' }}</v-btn>
            <v-btn text id="find" color="#FF5100" class="navtxt" to="/search">
              <v-icon color="#FF5100">search</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </nav>

    <v-layout v-else justify-start style="z-index: 100; width: 100%; height: 78px; position: fixed;"
      :style="{ 'background': curScrollPos > 410 ? 'rgba(255,255,255,.9)' : 'transparent' }">
      <v-flex shrink>
        <v-btn absolute fab class="ml-2 mt-3" style="min-width: unset; box-shadow: unset; background: transparent"
          @click.stop="drawer = !drawer">
          <v-icon large color="#000">dehaze</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-navigation-drawer v-model="drawer" absolute height="200vh"
      style="z-index: 9999; background: #FF5100; position: fixed;">
      <v-layout justify-space-between>
        <img width="60px" class="ml-3" style="cursor: pointer" @click="hrefTo('/overview')"
          :src="require('../assets/icon/footer-link-2.svg')">
        <v-layout justify-end pa-2>
          <v-flex shrink>
            <v-btn to="/search" fab>
              <v-icon color="#FFF">search</v-icon>
            </v-btn>
            <v-btn fab class="mx-2" style="font-weight: bold"
              @click="language === 'en' ? langSwitcher('th') : langSwitcher('en')">{{ language === 'en' ?
                'TH' : 'EN' }}</v-btn>

            <v-menu v-if="$vuetify.breakpoint.smAndDown">
              <template v-slot:activator="{ on }">
                <v-btn fab v-on="on" @click.stop="drawer = !drawer">
                  <v-icon color="#FFF">dehaze</v-icon>
                </v-btn>
              </template>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-layout>

      <v-list-item style="cursor: pointer" @click="routeToTab('')">
        <v-col class="shrink px-0">
          <v-list-item-title class="listmenu" style="cursor: pointer;" color="primary" @click="active = !active">
            {{ $t('creativity-index') }}
          </v-list-item-title>
          <v-expand-transition>
            <div class="mt-2" v-show="active" height="auto" width="100%">
              <v-list-item @click="routeToTab('')">
                <v-list class="text-left">
                  <v-list-item v-for="(item, i) in items" :key="i" @click="$router.push('/' + item.name)">
                    <v-list-item-title class="" :class="{ 'nav-active': $route.path === '/' + item.name }"
                      style="color: white">
                      <template v-if="language == 'en'">{{ item.title_en }}</template>
                      <template v-else>{{ item.title_th }}</template>
                      <!--                                {{ item.title_th }}-->
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-list-item>
            </div>
          </v-expand-transition>
        </v-col>
      </v-list-item>
      <v-list-item style="cursor: pointer" @click="$router.push('/industry')">
        <v-list-item-title class="listmenu" :class="{ 'nav-active': $route.path === '/industry' }">{{
          $t('data-and-statistic') }}</v-list-item-title>
      </v-list-item>
      <v-list-item style="cursor: pointer" @click="$router.push('/about')">
        <v-list-item-title class="listmenu" :class="{ 'nav-active': $route.path === '/about' }">{{ $t('about')
          }}</v-list-item-title>
      </v-list-item>
      <v-list-item style="cursor: pointer" @click="$router.push('/developer')">
        <v-list-item-title class="listmenu"
          :class="{ 'nav-active': ($route.path === '/developer' || $route.path.includes('/developerDetail')) }">{{
            $t('developer.developer') }}</v-list-item-title>
      </v-list-item>
    </v-navigation-drawer>
  </v-content>
</template>

<script>
import { mapActions, mapState } from "vuex";
import IndicatorMenu from "./IndicatorMenu";

export default {
  name: "Header",
  // eslint-disable-next-line vue/no-unused-components
  components: { IndicatorMenu },
  data: () => ({
    toggleNone: null,
    drawer: false,
    active: false,
    curScrollPos: null,
    industryParam: null,
    items: [
      { title_th: 'ประเทศไทย', title_en: 'Country', name: 'country' },
      { title_th: 'ต่างประเทศ', title_en: 'International', name: 'international' },
    ],
    menu: [],
    firstMenu: {}
  }),
  computed: {
    ...mapState({
      language: state => state.locale.language
    }),
    exitMobileSize: function () {
      return this.$vuetify.breakpoint.mdAndUp;
    }
  },
  watch: {
    exitMobileSize: function () {
      this.drawer = false;
      this.active = false;
    }
  },
  methods: {
    ...mapActions("locale", ["switchLang"]),
    ...mapActions('industry', ['populateIndustries']),
    ...mapActions('site', ['populateMainMenu', 'populateFirstMenu']),
    onScrollNavBar() {
      this.curScrollPos = window.pageYOffset;
    },
    routeToTab(tab) {
      switch (tab) {
        case "overview":
          if (this.$route.path !== '/overview') {
            this.$router.push("/overview");
          }
          break;
        case "industry":
          if (this.$route.path.indexOf('/industry/') === -1) {
            this.$router.push({ name: "industry", params: { category: this.industryParam ? this.industryParam : 'default-category' } });
          }
          break;
      }
    },
    langSwitcher(lang) {
      this.$i18n.locale = lang;
      this.switchLang(lang);
    },
    hrefTo(path) {
      this.$router.push(path)
    }
  },
  async created() {
    window.addEventListener("scroll", this.onScrollNavBar);
    let allCate = await this.populateIndustries();
    let selectedCate = allCate.filter(item => {
      return item.status === 1;
    });
    if (selectedCate[0]) {
      this.industryParam = selectedCate[0].name_en.replace(/ /g, '-');
    } else {
      console.error('default category wasn\'t set')
    }
    this.menu = await this.populateMainMenu();
    this.firstMenu = await this.populateFirstMenu();

  }
};
</script>

<style scoped lang="scss">
.navtxt {
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  color: #ff5100;
}

.navmenu {
  color: #ff5100 !important;
}

.listmenu {
  color: #fff;
  text-align: left;
  text-transform: uppercase;
}

.nav-active {
  color: #000 !important;
  cursor: unset !important;
}

.navtxt span:not(.nav-active):hover {
  opacity: 0.75;
}

.theme--light.v-btn-toggle {
  #hamburger {
    border: solid 1px #ff5100 !important;
    border-right: none !important;
  }

  #lang {
    border: solid 1px #ff5100 !important;
  }

  #find {
    border: solid 1px #ff5100 !important;
    border-left: 0 !important;
  }

  #find.v-item--active {
    background-color: #ff5100;

    i {
      color: #fff !important;
    }
  }
}

/* TODO: Use this after search function finished instead */
/*.theme--light.v-btn-toggle .theme--light.v-btn {*/
/*    border: solid 1px #FF5100 !important;*/
/*    &:not(:last-child) {*/
/*        border-right: none !important;*/
/*    }*/
/*}*/

.v-navigation-drawer__content .theme--light.v-btn {
  background-color: transparent !important;
  color: #fff;
  min-width: unset;
  box-shadow: unset;
}

.v-navigation-drawer__content .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: transparent !important;
}

.v-navigation-drawer__content .theme--light.v-btn-toggle {
  #hamburger {
    border: none !important;
    background-color: #ff5100 !important;
    color: #fff;
  }

  #lang {
    border: none !important;
    background-color: #ff5100 !important;
    color: #fff;
  }

  #find {
    border: none !important;
    background-color: #ff5100 !important;
    color: #fff;
  }

  .v-menu {
    justify-content: flex-start;
  }

  .left-align {
    justify-content: flex-start !important;
  }

  .no-flex {
    flex: none !important;
  }
}
</style>
